import { injectGlobal } from 'styled-components';
import { BackgroundColor, PastelPrimaryColor, PrimaryColor, ScrollbarColor, SurfaceColor } from './Utils';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions -- injectGlobal is called for its side effect
injectGlobal`
	:root {
		--surface-color: ${SurfaceColor};
		--background-color: ${BackgroundColor};
		--primary-color: ${PrimaryColor};
		--light-primary-color: ${PastelPrimaryColor};
		--scrollbar-color: ${ScrollbarColor};
	}
`;
